import {InputBaseProps, InputLabel, TextareaAutosize} from '@mui/material'
import classnames from 'classnames'
import React from 'react'

import useStyles from './style.hook'

/**
 * CustomTextarea
 */

interface CustomTextareaProps {
	id: string
	name?: string
	className?: string
	endAdornment?: React.ReactNode
	placeholder?: string
	value?: string | ReadonlyArray<string> | number
	onChange?: (
		e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
	) => void
	label?: string
	disabled?: boolean
	error?: string
	required?: boolean
	onBlur?: (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => void
	propsToDelegate?: InputBaseProps
}

const CustomTextarea: React.FC<CustomTextareaProps> = ({
	id,
	name,
	className,
	endAdornment,
	placeholder,
	value,
	onChange,
	label,
	disabled,
	required,
	error,
	onBlur,
	propsToDelegate,
}) => {
	// Get styles from component-scoped styles hook
	const classes = useStyles()

	return (
		<div
			id={id}
			className={classnames(classes.customTextarea, {
				[className]: className,
			})}
		>
			<div className={classes.labelContainer}>
				<InputLabel required={required} className={classes.label}>
					{label}
				</InputLabel>
				<span className={classes.error}>{error}</span>
			</div>
			<TextareaAutosize
				className={classes.textArea}
				name={name}
				placeholder={placeholder}
				endAdornment={endAdornment}
				value={value}
				onChange={onChange}
				disabled={disabled}
				onBlur={onBlur}
				{...propsToDelegate}
			/>
		</div>
	)
}

export default CustomTextarea
